<script>
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import HeatmapLayer from 'ol/layer/Heatmap';
import VectorSource from 'ol/source/Vector';
import vectorLayer from 'vuelayers/lib/mixin/vector-layer';
import { aggregateHeatmapPoints } from './ai-models/malaria-heatmap-utils';

export default {
  name: 'malaria-heatmap-layer',
  mixins: [vectorLayer],
  props: {
    points: {
      type: Array,
      default: () => []
    },
    radius: {
      type: Number,
      default: 18
    },
    blur: {
      type: Number,
      default: 22
    },
    gradient: {
      type: Array,
      default: () => ['rgba(255, 255, 178, 0)', '#fee08b', '#f46d43', '#a50026']
    },
    aggregationCellSize: {
      type: Number,
      default: 32
    },
    maxRenderedFeatures: {
      type: Number,
      default: 2500
    }
  },
  data() {
    return {
      heatmapSource: null
    };
  },
  mounted() {
    this.$mountPromise.then(() => {
      this.refreshFeatures(this.points);
    });
  },
  methods: {
    createLayer() {
      this.heatmapSource = new VectorSource({
        features: this.createFeatures(this.points)
      });

      return new HeatmapLayer({
        id: this.id,
        source: this.heatmapSource,
        visible: this.visible,
        opacity: this.opacity,
        extent: this.extent,
        zIndex: this.zIndex,
        radius: this.radius,
        blur: this.blur,
        gradient: this.gradient,
        weight: 'weight'
      });
    },
    createFeatures(points) {
      return this.aggregatedPoints(points)
        .map(point => {
          const feature = new Feature({
            geometry: new Point([Number(point.x), Number(point.y)])
          });
          feature.set('weight', Math.max(0, Math.min(1, Number(point.weight) || 0)));
          feature.set('id', point.id);
          feature.set('count', point.count || 1);
          return feature;
        });
    },
    aggregatedPoints(points) {
      return aggregateHeatmapPoints(points, {
        cellSize: this.aggregationCellSize,
        maxFeatures: this.maxRenderedFeatures
      });
    },
    refreshFeatures(points) {
      if (!this.heatmapSource) {
        return;
      }
      this.heatmapSource.clear(true);
      this.heatmapSource.addFeatures(this.createFeatures(points));
    }
  },
  watch: {
    points(points) {
      this.refreshFeatures(points);
    },
    radius(value) {
      if (this.$layer && this.$layer.setRadius) {
        this.$layer.setRadius(value);
      }
    },
    blur(value) {
      if (this.$layer && this.$layer.setBlur) {
        this.$layer.setBlur(value);
      }
    },
    gradient(value) {
      if (this.$layer && this.$layer.setGradient) {
        this.$layer.setGradient(value);
      }
    }
  }
};
</script>
